import React from "react";
import{Link} from 'react-router-dom'
import s from '../css/landin.module.css'
import can from "../image/can3.jpg"

export default function Landing(){
    return(
        <div className={s.landing}>
            <img  alt="img not found" className={s.can} src={can} />
            <h1 >Welcome to my Dog App </h1>
            <Link to="/home" >
                <button className={s.button}>Let's go...</button>
            </Link>
        </div>
       
    )
}